import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'

const isDev = process.env.NODE_ENV === 'development'

const createClient = (uri) => {
    const httpLink = new HttpLink({
        uri,
        credentials: 'include', // Adjust this based on your authentication needs
    })

    const errorLink = onError((error) => {
        const { graphQLErrors, networkError, operation } = error
        if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) => {
                if (isDev) {
                    console.error(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                    )
                }
            })
        }
        if (networkError) {
            if (isDev) console.error(`[Network error]: ${networkError.stack}`)
            const context = operation.getContext()
            if (context?.response?.status === 401) {
                // Handle unauthorized access
            }
        }
    })

    return new ApolloClient({
        cache: new InMemoryCache(),
        link: errorLink.concat(httpLink),
    })
}

export const accessClient = createClient(process.env.VUE_APP_ACCESS_BASE_GRAPHQL_URL)
export const courseClient = createClient(process.env.VUE_APP_COURSE_BASE_GRAPHQL_URL)
export const projectClient = createClient(process.env.VUE_APP_PROJECT_BASE_GRAPHQL_URL)
export const userClient = createClient(process.env.VUE_APP_USER_BASE_GRAPHQL_URL)
